import { render } from "./AmenitiesLabel.vue?vue&type=template&id=040b861a"
import script from "./AmenitiesLabel.vue?vue&type=script&lang=js"
export * from "./AmenitiesLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__